import React, { useContext, useState } from "react";
import { Modal } from "react-bootstrap";
import { Button,  ThemeProviderV2} from '@blueprint/ui';
import { useModal } from "react-modal-hook";

import claimApi from "../../../api/claim";
import { Loader, toast } from "../../../common/components/core";
import { useAuthErrorHandlerCreator } from "../../../common/hooks";
import { Handler } from "../../../types/common";
import { shortenUUID } from "../../../utils/common";
import {
    composeErrorHandlers,
    GenericError,
    onStaleStateError,
} from "../../../utils/errorHandling";
import ClaimContext from "../ClaimContext";

const useDiscardClaimHandler = (claimRef: string): Handler => {
    const [isSubmitting, setSubmitting] = useState(false);
    const onAuthError = useAuthErrorHandlerCreator();
    const { mutate } = useContext(ClaimContext);

    const [show, hide] = useModal(() => {
        const confirm = async () => {
            setSubmitting(true);
            try {
                const result = await claimApi.discard(claimRef);
//                 mutate(result.stateAndRefMap.ClaimState[0]);
                mutate( result.stateAndRefMap.BesuClaimState[0].state.data)
                const newClaimId =
                    result.stateAndRefMap.BesuClaimState[0].state.data.referenceId
                toast(`Claim #${shortenUUID(newClaimId ?? "")} discarded`);
                hide();
            } catch (e) {
                composeErrorHandlers(
                    onStaleStateError(() => {
                        mutate();
                        hide();
                        toast("Page has been updated by another user.");
                    }),
                    onAuthError,
                )(e as GenericError);
            }
            setSubmitting(false);
        };

        return (
            <ThemeProviderV2>
            <Modal show onHide={hide} backdrop="static" centered>
                <Loader overlay isLoading={isSubmitting}>
                    <Modal.Header>
                        <h2 className="mb-0">
                            Discard Claim Submission
                        </h2>
                    </Modal.Header>
                    <Modal.Body>
                        <p>
                            Are you sure you want to discard this claim
                            submission?
                        </p>
                    </Modal.Body>

                    <Modal.Footer className="d-flex justify-content-between px-3">
                        <Button variant="light.tertiary" onClick={hide}>
                            Cancel
                        </Button>
                        <Button variant="light.primary" onClick={confirm}>
                            Confirm
                        </Button>
                    </Modal.Footer>
                </Loader>
            </Modal>
            </ThemeProviderV2>
        );
    }, [claimRef, isSubmitting, mutate, onAuthError]);

    return {
        isSubmitting,
        handler: show,
    };
};

export default useDiscardClaimHandler;
